const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatchScan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      textIndent: 0,
      textAlign: "start",
      lineHeight: "normal",
      textTransform: "none",
      blockProgression: "tb",
      InkscapeFontSpecification: "Sans"
    },
    d: "M29.126 12.16l-3.644 3.64-3.612-3.64c-.45-.464-1.2.234-.71.71l3.967 3.993c.186.186.525.186.71 0l4-3.994c.49-.488-.238-1.18-.71-.71zM15.53 4.012c-4.307-.187-8.5 2.164-10.467 6.28-.288.6.59 1 .875.44 2.39-5 8.41-7.13 13.437-4.75 3.038 1.437 5.14 4.282 5.625 7.592.095.693 1.102.46 1-.156-.534-3.642-2.88-6.765-6.22-8.345-1.377-.652-2.813-1-4.25-1.062zM.875 17.843l3.644-3.64 3.612 3.64c.45.464 1.2-.234.71-.71L4.873 13.14c-.186-.186-.525-.186-.71 0l-4 3.993c-.49.488.238 1.18.71.71zM14.47 25.99c4.307.187 8.5-2.165 10.468-6.28.287-.6-.592-1-.875-.44-2.39 5-8.41 7.13-13.438 4.75C7.587 22.584 5.485 19.74 5 16.428c-.095-.693-1.102-.458-1 .156.534 3.642 2.88 6.764 6.22 8.344 1.377.653 2.813 1 4.25 1.063z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatchScan);
export default __webpack_public_path__ + "static/media/patch-scan.bcdbf5040984fb6f7e009f62635dcfe7.svg";
export { ForwardRef as ReactComponent };